import request from '@/utils/http'

const PREFIX = '/analyse/channel'

const analyseChannel = {
  analyse(params, isqueue) {
    return request(
      `${PREFIX}${isqueue ? '/queue' : ''}`,
      'post',
      params
    )
  }
}

export default analyseChannel
